// extracted by mini-css-extract-plugin
export default {"content":"style_content__aKikP","itemName":"style_itemName__7rka8"};